import { render, staticRenderFns } from "./avoidedCostsReports.vue?vue&type=template&id=392ad8fe&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./avoidedCostsReports.vue?vue&type=style&index=0&id=392ad8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392ad8fe",
  null
  
)

export default component.exports